import React, { Suspense, useState } from 'react';
import { Outlet, useNavigate, NavLink, useLocation } from 'react-router-dom';
import LoadingSpinner from '../../../../components/LoadingSpinner';
import { Search, Settings, Download, BookOpen, FileText, ClipboardCheck, Bell } from 'lucide-react';

const SOPLayout = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState('');
  const [activeFilter, setActiveFilter] = useState('all');

  const navItems = [
    { name: 'Overview', path: '/sop', icon: BookOpen },
    { name: 'Recipes', path: '/sop/recipes', icon: FileText },
    { name: 'Manuals', path: '/sop/manuals', icon: BookOpen },
    { name: 'Checklists', path: '/sop/checklists', icon: ClipboardCheck },
    { name: 'Announcements', path: '/sop/announcements', icon: Bell }
  ];

  return (
    <div className="min-h-screen">
      {/* Header Section */}
      <div>
        {/* Title Section */}
        <div className="max-w-7xl mx-auto px-8">
          <div className="pt-6 pb-4">
            <h1 className="text-2xl font-semibold text-gray-900">
              Standard Operating Procedures
            </h1>
            <p className="mt-1 text-sm text-gray-500">
              Monitoring quality standards across 12 locations
            </p>
          </div>
        </div>

        {/* Navigation Bar - Apple Style */}
        <div className="border-t border-gray-200">
          <div className="max-w-7xl mx-auto px-8">
            <div className="flex justify-center py-3">
              <div className="inline-flex rounded-full p-2">
                {navItems.map((item) => (
                  <NavLink
                    key={item.name}
                    to={item.path}
                    end={item.path === '/sop'}
                    className={({ isActive }) => `
                      flex items-center px-6 py-2.5 rounded-full text-sm font-medium
                      transition-all duration-200 ease-in-out min-w-[120px] justify-center
                      ${isActive 
                        ? 'bg-blue-700 text-white shadow-sm'
                        : 'text-gray-600 hover:bg-gray-100'
                      }
                    `}
                  >
                    <item.icon className="w-4 h-4 mr-2" />
                    {item.name}
                  </NavLink>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Search Section */}
      <div className="border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-8 py-4">
          <div className="flex gap-4">
            <div className="flex-1 relative">
              <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 w-5 h-5" />
              <input
                type="text"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                placeholder="Search across all SOPs..."
                className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500"
              />
            </div>
            <select
              value={activeFilter}
              onChange={(e) => setActiveFilter(e.target.value)}
              className="px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500"
            >
              <option value="all">All Types</option>
              <option value="recipes">Recipes</option>
              <option value="manuals">Manuals</option>
              <option value="checklists">Checklists</option>
              <option value="announcements">Announcements</option>
            </select>
          </div>
        </div>
      </div>

      {/* Main Content Area */}
      <div className="flex-1">
        <div className="max-w-7xl mx-auto px-8 py-6">
          <Suspense fallback={<LoadingSpinner />}>
            <Outlet />
          </Suspense>
        </div>
      </div>
    </div>
  );
};

export default SOPLayout; 